var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[_c('img',{staticClass:"svg-sprite",attrs:{"id":"svg-sprite","src":require("./assets/img/sprite.svg"),"alt":"svg-sprite"}}),_c('router-view'),_c('confirm-modal',{ref:"confirmModal"})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }